import React, { useEffect, useRef } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "./Markets.css";

const Markets = () => {
  const location = useLocation();
  const outletRef = useRef(null);

  useEffect(() => {
    if (outletRef.current) {
      outletRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [location]);

  const services = [
    { label: "Overview", route: "overview" },
    { label: "Trading Data", route: "tradingData" },
    { label: "Token Unlock", route: "tokenUnlock" },
  ];

  const activeRoute = location.pathname.split("/").pop();

  return (
    <>

      <div className="markets-page">
        <Header />

        <div className="markets-content">
          <div className="markets-tabs">
           
            {services.map((service) => (
              <Link
                key={service.route}
                to={`/markets/${service.route}`}
                className={activeRoute === service.route ? "active" : ""}
                aria-current={activeRoute === service.route ? "page" : undefined}
              >
                {service.label}
              </Link>
            ))}
          </div>

          <div ref={outletRef}>
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Markets;
